/* global formValidation ga*/
const submitFormSearchBox = {
	el: {
		body: document.body,
		formContainer: document.querySelector('.js-searchbox-form'),
		modalPreloader: document.querySelector('.modal-preloader')
	},

	fxPreloaderModal() {
		this.el.body.classList.add('no-scroll-fixed')
		this.el.modalPreloader.style.display = 'flex'
	},

	fxSubmitFormSearchBox() {
		this.el.formContainer.addEventListener('submit', e => {
			e.preventDefault()
			const el = e.currentTarget

			if (formValidation.fxValidate(el)) {
				const data = new FormData(el)

				data.set('arrivaldate', data.get('arrivaldate').replaceAll('-', ''))
				data.set('departuredate', data.get('departuredate').replaceAll('-', ''))

				const formValues = new URLSearchParams(data).toString()

				window.open(`${el.action}?${formValues}`, '_blank')

				if (window.ga && ga.loaded)
					ga('send', 'event', { 'eventCategory': 'booking', 'eventAction': 'click', 'eventLabel': 'step1', 'eventValue': 1 })
			}
		})
	},

	events() {
		this.el.formContainer && this.fxSubmitFormSearchBox()
	},

	init() {
		this.events()
	}
}

submitFormSearchBox.init()
